export const calculateItemPrice = {
    methods: {
        calculateItemPrice(data) {
            // console.log('calculate item price data: ', data);
            let product = data.product;
            let quantity = data.quantity;

            let optionsTotal = 0;
            let selectedOptions = JSON.parse(JSON.stringify(product.selectedOptions));
            // console.log('selected Options', selectedOptions);
            if (selectedOptions && Object.keys(selectedOptions).length > 0) {
                // console.log('selectedOptions value added..', selectedOptions)
                Object.keys(selectedOptions).forEach((key) => {
                    optionsTotal += selectedOptions[key].price;
                });
            }
            // console.log('optionsTotal', optionsTotal)
            let accessoriesTotal = 0;
            // console.log('calculateItemPrice selectedAccessories', product.selectedAccessories);
            if (product.selectedAccessories) {
                Object.keys(product.selectedAccessories).forEach((key) => {
                    accessoriesTotal += product.selectedAccessories[key].price * product.selectedAccessories[key].count;
                });
            }

            let discountedSalePrice = Object.freeze(product.sale_price);

            if(product.sales_discounts) {
                for (let i = 0; i < product.sales_discounts.length; i++) {
                    if (quantity >= product.sales_discounts[i].from_count && quantity <= product.sales_discounts[i].to_count) {
                        discountedSalePrice = product.sale_price - product.sales_discounts[i].price;
                        break;
                    } else if (product.sales_discounts[i].to_count === 0) {
                        discountedSalePrice = product.sale_price - product.sales_discounts[i].price;
                    }
                }
            }
            return discountedSalePrice + optionsTotal + accessoriesTotal;
        }
    }
}
export default calculateItemPrice;